var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDocIntelligence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 42,
    viewBox: "0 0 33 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23.8572,
    height: 29.7756,
    rx: 3.5,
    fill: "#E8E8E8",
    stroke: "#707070"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5498,
    y: 3.5498,
    width: 6.51022,
    height: 6.51022,
    fill: "#241CCA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2461,
    y: 5.32715,
    width: 7.69389,
    height: 1.18368,
    fill: "#707070"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2461,
    y: 7.69336,
    width: 10.0612,
    height: 1.18368,
    fill: "#707070"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5498,
    y: 12.4287,
    width: 4.7347,
    height: 4.7347,
    fill: "#BCBCBC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.87695,
    y: 13.0205,
    width: 9.46941,
    height: 1.18368,
    fill: "#BCBCBC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.87695,
    y: 15.3887,
    width: 13.0204,
    height: 1.18368,
    fill: "#BCBCBC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5498,
    y: 20.123,
    width: 4.7347,
    height: 4.7347,
    fill: "#BCBCBC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.87695,
    y: 20.7139,
    width: 9.46941,
    height: 1.18368,
    fill: "#BCBCBC"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 8.87695,
    y: 23.0811,
    width: 13.0204,
    height: 1.18368,
    fill: "#BCBCBC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1780_53371)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.398,
    cy: 26.398,
    r: 7.39797,
    fill: "#241CCA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.735 30.035V23.465H21.995V30.035H20.735ZM18.005 27.35V26.165H24.725V27.35H18.005Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1780_53371",
    x: 10,
    y: 19,
    width: 22.7959,
    height: 22.7959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1780_53371"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1780_53371",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDocIntelligence);
export default __webpack_public_path__ + "static/media/add-doc-intelligence.7cfa60b7ade083a1e54f428c29f99243.svg";
export { ForwardRef as ReactComponent };